import { render, staticRenderFns } from "./FormIndicationsOfDanger.vue?vue&type=template&id=932194ec"
import script from "./FormIndicationsOfDanger.vue?vue&type=script&lang=js"
export * from "./FormIndicationsOfDanger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports